import React from "react";
import { Icon } from "semantic-ui-react";

import { ProductsTableActions } from "./ProductsTableActions";
import { PRICE_BASIS_LABELS } from "routes/product/pricing/pricing";

const priceColumns = isPricingEnabled =>
  isPricingEnabled
    ? [
        {
          header: "Current Price",
          id: "Current Price",
          accessorKey: "list_price",
        },
        {
          header: "Allowed Terms",
          id: "Allowed Terms",
          accessorKey: "allowed_terms",
          enableSorting: false,
          cell: ({ row }) => (row.original.allowed_terms ?? []).join(", "),
        },
        {
          header: "Price Basis",
          id: "Price Basis",
          accessorKey: "price_basis",
          cell: ({ row }) => PRICE_BASIS_LABELS[row.original.price_basis],
        },
      ]
    : [
        {
          header: "List Price",
          id: "List Price",
          accessorKey: "list_price",
        },
      ];

export const getProductsTableColumns = ({ isPricingEnabled = false } = {}) => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original?.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    ...priceColumns(isPricingEnabled),
    {
      header: "Enabled",
      id: "Enabled",
      accessorKey: "enabled",
      size: 80,
      cell: ({ row }) => (
        <Icon
          name={row.original.enabled ? "check" : "close"}
          color={row.original.enabled ? "green" : "red"}
        />
      ),
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <ProductsTableActions original={row.original} />,
    },
  ];
};

export const getProductsTableFilters = ({ isPricingEnabled = false } = {}) => [
  {
    key: "list_price",
    title: isPricingEnabled ? "Current Price" : "List Price",
    type: "range",
  },
  {
    key: "enabled",
    title: "Status",
    type: "select",
    data: [
      { id: true, name: "Enabled" },
      { id: false, name: "Disabled" },
    ],
  },
];
